
import { Options, Vue } from 'vue-class-component'

@Options({
  computed: {
    alertMessageOptions() {
      return this.$store.state.alertMessage.alertMessageOptions
    },
  }
})
export default class AlertMessage extends Vue {}
